module.exports = __webpack_public_path__ + "static/scale-model-of-chamberlin-observatory-in-denver-colorado-fd06e8267e8c4468ac01e78b816bf4ef.png";